export const appKeyOptions = [{ label: 'All', value: '' }]

export const platformOptions = [
  { label: 'All', value: '' },
  { label: 'Android', value: 'android' },
  { label: 'iOS', value: 'ios' },
]

export const statusOptions = [
  {
    label: 'All',
    value: '',
  },
  {
    label: 'Draft',
    value: 'draft',
  },
  { label: 'Prepared', value: 'prepared' },
  { label: 'Compiled', value: 'compiled' },
  { label: 'Stopped', value: 'stopped' },
]

export const capabilitiesOptions = [
  { label: 'All', value: '' },
  { label: 'Capability1', value: 'cap1' },
  { label: 'Capability2', value: 'cap2' },
]

export const navigationTargetsOptions = [
  { label: 'All', value: '' },
  { label: 'App gallery', value: 'app_gallery' },
  { label: 'Login', value: 'login' },
]

export const orderByOptions = [
  { label: 'Created at ascending', value: 'created_at ASC' },
  { label: 'Created at descending', value: 'created_at DESC' },
  { label: 'Updated at ascending', value: 'updated_at ASC' },
  { label: 'Updated at descending', value: 'updated_at DESC' },
  { label: 'Status ascending', value: 'status ASC' },
  { label: 'Status descending', value: 'status DESC' },
]

export const PAGE_CONTAINER_DEFAULT_TITLE = 'Enter a title'
